import type { ReactNode } from "react"
import { useLocation } from "react-router-dom"

import { headerAccentClass, sectionFromPath } from "@/lib/nav"
import { cn } from "@/lib/utils"

export function AdminPageHeader({
  children,
  description,
  title,
}: {
  children?: ReactNode
  description?: string
  title: string
}) {
  const { pathname } = useLocation()
  return (
    <header className="mb-6 flex flex-wrap items-start justify-between gap-4">
      <div className={headerAccentClass(sectionFromPath(pathname))}>
        <h1 className="text-xl font-semibold tracking-tight text-foreground">{title}</h1>
        {description ? <p className="mt-1 text-sm text-muted-foreground">{description}</p> : null}
      </div>
      {children ? <div className="flex flex-wrap items-center gap-2">{children}</div> : null}
    </header>
  )
}
